import { CountryCd } from "@xpo-ltl/sdk-common";

export class State {
  countryCd: CountryCd;
  states: string[];

  constructor(countryCd: CountryCd, states: string[] = []) {
    this.countryCd = countryCd;
    this.states = states;
  }
}
